import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { globalDashboardContainer } from '../../di/container';

export function useStudentVsGeneral(email: string) {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: [
      'global-dashboard',
      'student-vs-general',
      institutionName,
      email,
    ],
    queryFn: () =>
      globalDashboardContainer.repository.getStudentVSGeneral(email),
    enabled: isAuthenticated && !!email,
    retry: false,
  });
}
